import React, { ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import FormatService from '../../services/format-service';
import useStylesControlModeBlock from './control-mode-block.styles';

const ControlModeBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isHidden,
    isMultiline,
    children,
  } = props;

  const { classes } = useStylesControlModeBlock();

  const hiddenClassName: string | undefined = isHidden ? classes.controlModeBlockHidden : undefined;
  const multilineClassName: string | undefined = isMultiline ? classes.controlModeBlockMultiline : undefined;

  return (
    <FlexContainer
      className={FormatService.formatClassNames(classes.controlModeBlock, hiddenClassName, multilineClassName)}
    >
      {children}
    </FlexContainer>
  );
});

export default ControlModeBlock;
